// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import storage from 'good-storage'

Vue.config.productionTip = true
Vue.use(ElementUI)
/* eslint-disable no-new */

const qs = require('qs')
let urls = window.location.href
let parseUrl = qs.parse(urls.split('?')[1])
router.beforeEach((to, from, next) => {
  if(storage.get('bookersL', 'uft') === 'uft'){
    if (parseUrl.code === undefined) {
      let url = encodeURIComponent(urls)
      let opneparseUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww4879f067e079ec98&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      window.location.href = opneparseUrl
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js